<template>
<v-form
  v-model='isValid'
  ref='form'
  @submit.stop.prevent='save'
  @keydown.meta.83.prevent='save' >
  <v-card :flat='flat'>
    <slot name='top' :settings='settings' >
    </slot>
    <v-card-title class='pl-0' v-if='title' >{{title}}</v-card-title>
    <v-layout row wrap >
      <!-- <pre v-text='data' /> -->
      <template v-for='field in fields' >
        <slot
          :name='"field-" + field.id'
          :field='field' :val='data[field.id]' >
        <v-flex
          v-if='showField(field, data)'
          v-bind='field.containerAttrs'
          class='pa-2' >
          <template v-if='field.component === "subheader"' >
            <v-chip label dark
              class='rounded-0 my-0' >
              <v-avatar left v-if='field.icon' >
                <v-icon :color='field.iconColor'>{{field.icon}}</v-icon>
              </v-avatar>
              {{field.text}}
            </v-chip>
            <v-divider class='black lighten-2' />
          </template>
          <template v-if='field.component === "divider"' >
            <v-divider />
          </template>
          <v-checkbox
            v-else-if='field.component === "vcheckbox"'
            v-bind='field.attrs'
            :error-messages='getErrors(field.id)'
            v-model='data[field.id]' >
          </v-checkbox>
          <v-select v-else-if='field.component === "vselect"'
            v-bind='field.attrs'
            :error-messages='getErrors(field.id)'
            v-model='data[field.id]' >
          </v-select>
          <v-textarea v-else-if="field.component === 'vtextarea'"
            v-bind='field.attrs'
            :error-messages='getErrors(field.id)'
            v-model='data[field.id]' >
          </v-textarea>
          <v-alert v-else-if="field.component === 'valert'"
            v-bind='field.attrs' >
            {{field.text}}
          </v-alert>
          <component
            v-else-if='field.component'
            :is="field.component"
            v-bind='field.attrs'
            v-on='field.events || {}'
            :error-messages='getErrors(field.id)'
            v-model='data[field.id]' >
          </component>
          <v-text-field
            v-else
            v-bind='field.attrs'
            :error-messages='getErrors(field.id)'
            v-model='data[field.id]' >
          </v-text-field>
        </v-flex>
        </slot>
      </template>
    </v-layout>
    <v-card-actions v-if='request' >
      <slot name='actions-left' >
        <v-btn v-if='deleteRequest && id' @click.prevent='performDelete' color="error" >Delete</v-btn>
      </slot>
      <v-spacer></v-spacer>
      <!-- :disabled='!isValid' -->
      <v-btn @click="$emit('close')" class="mr-3" text v-if="withClose" >Close</v-btn>
      <v-btn type='submit'
        :loading='request.loading'
        color='primary' >Save</v-btn>
    </v-card-actions>
  </v-card>
  <v-bottom-sheet v-model='bottomSheet' inset >
    <v-card class='mb-10 pb-10' v-if='isError' flat>
      <v-card-title class='overline py-0 red lighten-3' >
        Some of the values you submitted are not valid
        <v-spacer></v-spacer>
        <v-btn icon small @click='bottomSheet=false; snacker.visible=false' ><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <ul v-for='(errors, field) in request.errors' :key='field' >
          <li><strong>{{field}}</strong>
            <ul>
              <li v-for='error in errors' :key='error' >
                {{error}}
              </li>
            </ul>
          </li>
        </ul>
      </v-card-text>
    </v-card>
  </v-bottom-sheet>
  <v-snackbar v-model='snacker.visible' :color='snacker.color' :timeout=snacker.timeout >
    {{snacker.message}}
    <v-btn v-if='isError' @click='bottomSheet = true' small text dark >More</v-btn>
    <v-btn @click='snacker.visible=false;bottomSheet=false' small text dark >Close</v-btn>
  </v-snackbar>
  <!-- <pre>{{data}}</pre> -->
</v-form>
</template>
<script>
import Vue from 'vue'
export default {
  name: 'DataForm',
  props: {
    title: { type: String, required: false },
    id: { required: false },
    value: { type: Object, required: true },
    fields: { type: Array, default: () => { return [] } },
    request: { type: Object },
    deleteRequest: { type: Object },
    saveOnBlur: { type: Boolean, default: false },
    flat: { type: Boolean, default: true },
    touchClear: { type: Number, default: 0 },
    showExtraFields: { type: Boolean, default: true },
    triggerSave: { type: Number, default: 0 },
    withClose: { type: Boolean, default: false }
  },
  data () {
    return {
      isValid: false,
      data: {},
      local_request: {},
      localDeleteRequest: {},
      bottomSheet: false,
      snacker: {
        color: 'green',
        timeout: 3000,
        visible: false,
        message: ''
      },
      settings: {
        showExtraFields: false
      }
    }
  },
  mounted () {
    Vue.set(this.settings, 'showExtraFields', this.showExtraFields)
  },
  methods: {
    save () {
      if (this.id) {
        this.local_request.resourceId = this.id
        this.local_request.method = 'patch'
      }
      this.local_request.data = this.formattedData
      this.$request('save', this.local_request)
    },
    performDelete () {
      // copy deleteRequest
      this.localDeleteRequest = JSON.parse(JSON.stringify(this.deleteRequest))
      this.localDeleteRequest.resourceId = this.id
      this.$request('delete', this.localDeleteRequest)
    },
    setSnacker (color, message) {
      this.snacker.visible = false
      this.snacker.color = color
      this.snacker.message = message
      this.snacker.visible = true
      if (this.isError) {
        this.snacker.timeout = 0
      } else {
        this.snacker.timeout = 3000
      }
    },
    clear () {
      this.fields.forEach((field) => {
        if (field && field.id) {
          Vue.set(this.value, field.id, '')
        }
      })
    },
    clearServerErrors (fieldId) {
      console.log(fieldId)
      if (this.request.errors) {
        Vue.delete(this.request.errors, fieldId)
      }
    },
    getErrors (fieldId) {
      if (this.request && this.request.errors && (fieldId in this.request.errors)) {
        return this.request.errors[fieldId]
      }
      return []
    },
    showField (field, data) {
      if (field.onlyIfTrue) {
        let testValue = data[field.onlyIfTrue]
        return (testValue === true)
      }
      return true
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) { this.data = this.value }
      }
    },
    request: {
      immediate: true,
      handler () {
        if (this.request) { this.local_request = this.request }
        if (this.request.status === 200) { this.dirty = false }
      }
    },
    triggerSave () {
      this.save()
    },
    touchClear () {
      this.clear()
    },
    local_request () {
      this.$emit('update:request', this.local_request)
    },
    requestStatus () {
      if (this.requestStatus === 200) {
        this.$emit("saved", this.request.result)
        this.setSnacker('success', 'Changes successfully saved')
      }
      if (this.requestStatus === 201) {
        this.$emit("created", this.request.result)
        this.setSnacker('success', 'New item created')
      }
      if (this.requestStatus === 400) {
        this.setSnacker('error', 'There were some issues saving your data')
      }
      if (this.requestStatus === 401 || this.requestStatus === 403) {
        this.setSnacker('warning', 'Access denied')
      }
    }
  },
  computed: {
    requestStatus () {
      if (this.request) {
        return this.request.status
      }
      return 0
    },
    isError () {
      return (this.requestStatus >= 300)
    },
    formattedData () {
      let formattedData = {}
      this.fields.forEach((field) => {
        let val = this.data[field.id]
        console.log(field)
        if (field.transform) { val = field.transform(val) }
        formattedData[field.id] = val
      })
      return formattedData
    }
  }
}
</script>
